class LuxuryVideoCarousel {

    constructor() {

        this.videos = [...document.querySelectorAll(".ll-video")];

        this.init();

    }

    init() {

          this.bindPlayButtons();
         this.bindMuteButtons();
         this.initCarouselAutoplay();

    }

    bindPlayButtons() {

        this.videos.forEach(video => {

            const card = video.closest(".ll-card");

            const playBtn = card.querySelector(".ll-play-btn");

            playBtn.addEventListener("click", () => {

                this.pauseOthers(video);

                if(video.paused){

                    video.play();

                }else{

                    video.pause();

                }

            });

            video.addEventListener("click",()=>{

                playBtn.click();

            });

            video.addEventListener("play",()=>{

                playBtn.classList.add("hidden");

            });

            video.addEventListener("pause",()=>{

                playBtn.classList.remove("hidden");

            });

        });

    }

    bindMuteButtons(){

        this.videos.forEach(video=>{

            const card=video.closest(".ll-card");

            const muteBtn=card.querySelector(".ll-mute-btn");

            muteBtn.addEventListener("click",()=>{

                video.muted=!video.muted;

                muteBtn.textContent=video.muted ? "🔇":"🔊";

            });

        });

    }
    pauseOthers(current){

    this.videos.forEach(video=>{

        const btn = video
            .closest(".ll-card")
            .querySelector(".ll-play-btn");

        if(video === current){

            btn.classList.add("hidden");
            return;

        }

        if(!video.paused){

            video.pause();

        }

        btn.classList.remove("hidden");

    });

}
    initCarouselAutoplay(){

    const carousel = document.querySelector(".ll-carousel");

    if(!carousel) return;

    const updateActiveVideo = () =>{

        const carouselRect = carousel.getBoundingClientRect();
        const center = carouselRect.left + carouselRect.width / 2;

        let closestVideo = null;
        let closestDistance = Infinity;

        this.videos.forEach(video=>{

            const rect = video.getBoundingClientRect();
            const videoCenter = rect.left + rect.width / 2;

            const distance = Math.abs(center - videoCenter);

            if(distance < closestDistance){

                closestDistance = distance;
                closestVideo = video;

            }

        });

        if(!closestVideo) return;

        this.pauseOthers(closestVideo);

        if(closestVideo.paused){

            closestVideo.play().catch(()=>{});

        }

    };

    let timer;

    carousel.addEventListener("scroll",()=>{

        clearTimeout(timer);

        timer = setTimeout(updateActiveVideo,100);

    });

    window.addEventListener("resize",updateActiveVideo);

    setTimeout(updateActiveVideo,500);

}

}

document.addEventListener("DOMContentLoaded",()=>{

    new LuxuryVideoCarousel();

});